<template>
    <div class="buttons">
        <b-button variant="default" @click="$bvModal.show(modalId)">
            <font-awesome-icon :icon="['fas', 'eye']" />
        </b-button>
        <modal title="Original Request" scrollable ok-only :id="modalId">
            <pre>{{ formattedInvoice }}</pre>
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            modalId: null,
            request: null,
        };
    },
    computed: {
        formattedInvoice() {
            if (!this.request) return '';
            try {
                const parsed = JSON.parse(this.request);
                return JSON.stringify(parsed, null, 2);
            } catch (e) {
                return this.request;
            }
        },
    },
    mounted() {
        this.modalId = this.params?.data?.id.toString();
        this.request = this.params?.data?.original_request;
    },
};
</script>

<style lang="scss" scoped>
.buttons {
    display: flex;
    justify-content: center;
}
pre {
    white-space: pre-wrap; /* Ensure text wraps within the modal */
    font-family: monospace; /* Consistent monospaced font for JSON */
    margin: 0; /* Remove default margins */
    padding: 1rem; /* Add padding for readability */
    background-color: #f8f8f8; /* Light background for contrast */
    border-radius: 4px; /* Optional: rounded corners */
}
</style>